import React from "react"

import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"

import { Box, CircularProgress, Paper } from "@mui/material"
import { Typography } from "@synapse-analytics/synapse-ui"

import { MonacoTextEditor } from "../../../components/data-display/MonacoTextEditor"
import type { RootState } from "../../../store/ReduxStore"
import { getHostnames } from "../../../utils/genericHelpers"

import styles from "../Registry.module.scss"

export function RegistryCredentials(): React.ReactElement {
  const orgId = useSelector((state: RootState) => state.auth.organizationId) as string

  const userEmail = useSelector((state: RootState) => state.auth.email)

  const { t } = useTranslation("registry", {
    keyPrefix: "RegistryCredentials",
  })

  const registryPushingcodeSnippet =
    t("codeComments.login") +
    `docker login -u ${userEmail} -p <password> ${getHostnames().registry}\n` +
    "\n" +
    t("codeComments.tag") +
    `docker tag <image>:<tag> ${getHostnames().registry}/${orgId}/<image>:<tag>\n` +
    "\n" +
    t("codeComments.push") +
    `docker push ${getHostnames().registry}/${orgId}/<image>:<tag>`

  return (
    <Paper className={styles.creds}>
      <Typography variant="h2-bold">{t("title")}</Typography>
      <Typography variant="p">{t("subtitle")}</Typography>
      <Box m={3} />

      <Typography variant="h3-regular" gutterBottom>
        {t("pushingImagesTitle")}
      </Typography>

      <MonacoTextEditor
        value={registryPushingcodeSnippet}
        language={"shell"}
        readOnly
        automaticLayout
        lineNumbers="off"
        loading={<CircularProgress style={{ color: "rgb(25 118 210)" }} size={36} />}
      />
    </Paper>
  )
}
